import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import OverlayTrigger from '../../OverlayTrigger';
import SearchBarHistoryOverlay from '../SearchBarHistoryOverlay';
import { SEARCH_KEY } from '../../../_shared/constants/search';
import {
  SearchIcon,
  ModalSearchAreaWrapper,
  ModalSearchIconWrapper,
  ModalInputField,
  ModalSearchButton,
  SearchInputWrapper,
  OmpSearchIcon
} from '../Styles';

const SearchBar = ({
  testId,
  searchInputRef,
  handleSearch = () => {},
  enableHistoryOverlay = false,
  onHistoryItemClick = () => {},
  recentSearches = [],
  isOmp,
  isOmpSearchBarOnly,
  applyPadding = false,
  showingResults
}) => {
  const intl = useIntl();
  let closeRecentSearchOverlayCallback;
  const internalHandleSearch = (...args) => {
    if (!searchInputRef.current.value) {
      return;
    }
    if (typeof closeRecentSearchOverlayCallback === 'function') {
      closeRecentSearchOverlayCallback();
    }
    handleSearch(...args);
  };

  const onInputKeyDown = event => {
    if (event.keyCode === SEARCH_KEY.ENTER) {
      internalHandleSearch();
    }
  };

  const historyOverlay = enableHistoryOverlay ? (
    <SearchBarHistoryOverlay
      recentSearches={recentSearches}
      onHistoryItemClick={onHistoryItemClick}
    />
  ) : (
    <></>
  );

  return (
    <ModalSearchAreaWrapper
      isOmpSearchBarOnly={isOmpSearchBarOnly}
      applyPadding={applyPadding}
    >
      <SearchInputWrapper>
        <ModalSearchIconWrapper>
          {isOmp ? <OmpSearchIcon /> : <SearchIcon />}
        </ModalSearchIconWrapper>
        <OverlayTrigger
          onRef={callback => {
            closeRecentSearchOverlayCallback = callback;
          }}
          style={{ width: '100%' }}
          placement="bottom"
          overlay={historyOverlay}
          offset={{ top: 10, left: 20 }}
        >
          <ModalInputField
            data-testid={`${testId}-searchModal-searchField`}
            ref={searchInputRef}
            type="text"
            name="searchInput"
            autoComplete="off"
            placeholder={
              isOmp
                ? intl.formatMessage({
                    id:
                      'list.nav.searchbar.modal.searchbar.placeholder.omp.sell'
                  })
                : intl.formatMessage({
                    id: 'list.nav.searchbar.modal.searchbar.placeholder'
                  })
            }
            onKeyDown={e => onInputKeyDown(e)}
            showingResults={showingResults}
            isOmp={isOmp}
            isOmpSearchBarOnly={isOmpSearchBarOnly}
          />
        </OverlayTrigger>
      </SearchInputWrapper>
      <ModalSearchButton
        data-testid={`${testId}-searchModal-searchButton`}
        onClick={e => internalHandleSearch(e)}
        isOmpSearchBarOnly={isOmpSearchBarOnly}
      >
        <FormattedMessage id="list.nav.searchbar.modal.searchButton" />
      </ModalSearchButton>
    </ModalSearchAreaWrapper>
  );
};

export default SearchBar;
